<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="客服人员配置" name="customerServicePersonnel"> </el-tab-pane>
        <el-tab-pane label="组长权限配置" name="teamLeaderAuthority" v-if="columnJurisdiction"> </el-tab-pane>
        <el-tab-pane label="检查项配置" name="inspectionItems"> </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent"></component>
    </content-panel>
  </div>
</template>

<script>
import customerServicePersonnel from "./customerServicePersonnel/customerServicePersonnel";
import teamLeaderAuthority from "./teamLeaderAuthority/teamLeaderAuthority";
import inspectionItems from "./inspectionItems/inspectionItems";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "QualityTestingManageBaseConfig",
  mixins: [pagePathMixin],
  components: { customerServicePersonnel, teamLeaderAuthority, inspectionItems },
  data() {
    return {
      activeName: "customerServicePersonnel",
      columnJurisdiction: false
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
    let buttonJurisdiction = JSON.parse(localStorage.getItem("permitList")); //列展示权限获取
    let Jurisdiction = "ec-pc-new$configurationCenter$productManagementConfiguration$newproductBaseConfig$groupLeader";
    this.columnJurisdiction = buttonJurisdiction.includes(Jurisdiction);
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>
